<template>
    <b-modal v-model="show" centered size="xl" hide-footer>
        <div class="row">

            <div class="col-sm-4">
                <p class="mb-4 title">Mitä uutta Dotagissa?</p>
                <p class="text-lg-left content">
                    Toisten merkintöjen jatkaminen mahdollista viikosta 37 lähtien. Katso video miten tämä toimii.
                </p>
            </div>
            <div v-if="videoUrl" class="col-sm-8">
                <div class="embed-responsive embed-responsive-16by9 mb-3">
                    <iframe
                        class="embed-responsive-item"
                        :src="videoUrl"
                        allowfullscreen
                    ></iframe>
                </div>
            </div>
            <p v-else class="col-sm-8 text-muted font-italic">
                Video coming soon.
            </p>
        </div>
        <div class="d-flex justify-content-between align-items-center">
            <b-form-checkbox v-model="dontShowAgain">Don't show this again</b-form-checkbox>
            <b-button variant="primary" @click="close">Close</b-button>
        </div>
    </b-modal>
</template>

<script>
const HIDE_COOKIE = 'hide_whats_new_dotag';
const COOLDOWN_COOKIE = 'whats_new_dotag_last_shown';
const COOLDOWN_HOURS = 4;

export default {
    name: 'WhatsNewModal',
    data() {
        return {
            show: false,
            dontShowAgain: false,
            // TODO: set to the real video embed URL (e.g. a YouTube/Vimeo embed link)
            videoUrl: 'https://www.youtube.com/embed/bCo2XIc-Ac0?si=xr9fDvENX4Cjoc00',
        };
    },
    mounted() {
        if (!this.getCookie(HIDE_COOKIE) && !this.getCookie(COOLDOWN_COOKIE)) {
            this.show = true;
        }
    },
    methods: {
        getCookie(name) {
            const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
            return match ? decodeURIComponent(match[1]) : null;
        },
        setCookie(name, value, hours) {
            const expires = new Date(Date.now() + hours * 60 * 60 * 1000).toUTCString();
            document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=/';
        },
        close() {
            if (this.dontShowAgain) {
                this.setCookie(HIDE_COOKIE, '1', 365 * 24);
            } else {
                // A hard refresh doesn't persist any session state, so without this the
                // modal would immediately reappear - suppress re-showing for a while,
                // then show it again next time unless the box above gets checked.
                this.setCookie(COOLDOWN_COOKIE, '1', COOLDOWN_HOURS);
            }
            this.show = false;
        },
    },
};
</script>

<style scoped>
    .title {
        font-size: 35px;
        letter-spacing: 2px;
        word-spacing: 2px;
        color: #2b2b2b;
        font-weight: 700;
        text-decoration: none;
        font-style: normal;
        font-variant: normal;
        text-transform: none;
    }
    .content {
        font-size: 24px;
        letter-spacing: 2px;
        word-spacing: 2px;
        color: #212121;
        font-weight: 400;
        text-decoration: none;
        font-style: normal;
        font-variant: normal;
        text-transform: none;
    }

</style>
